import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const XMark: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="x-mark icon">
      {/* <title>x-mark icon</title> */}

      <g id="xmark">
        <path
          id="Vector"
          d="M17.5644 15.957C18.0316 16.4242 18.0316 17.1823 17.5644 17.6496C17.0972 18.1168 16.3391 18.1168 15.8718 17.6496L9.97919 11.713L4.04466 17.6476C3.57743 18.1148 2.81935 18.1148 2.35207 17.6476C1.88479 17.1803 1.88484 16.4223 2.35207 15.955L8.28859 10.0224L2.35042 4.04303C1.88319 3.5758 1.88319 2.81772 2.35042 2.35044C2.81766 1.88316 3.57573 1.88321 4.04301 2.35044L9.97919 8.33185L15.9137 2.39732C16.3809 1.93009 17.139 1.93009 17.6063 2.39732C18.0736 2.86455 18.0735 3.62263 17.6063 4.08991L11.6698 10.0224L17.5644 15.957Z"
          fill="#A1A1AA"
        />
      </g>
    </svg>
  );
};

export default XMark;
